/**
 * @generated SignedSource<<4530a6174932635e8841a17274e4dcfb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectUpdatesQuery$variables = {
  isUpdatesTab: boolean;
  key: string;
};
export type ProjectUpdatesQuery$data = {
  readonly project: {
    readonly key?: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectUpdates">;
  } | null;
};
export type ProjectUpdatesQuery = {
  response: ProjectUpdatesQuery$data;
  variables: ProjectUpdatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUpdatesTab"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v7 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v8 = {
  "kind": "ScalarField",
  "name": "ari"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v11 = {
  "kind": "ScalarField",
  "name": "summary"
},
v12 = {
  "kind": "ScalarField",
  "name": "title"
},
v13 = {
  "kind": "ScalarField",
  "name": "label"
},
v14 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v15 = {
  "kind": "ScalarField",
  "name": "picture"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v18 = [
  (v3/*: any*/),
  (v8/*: any*/),
  (v4/*: any*/)
],
v19 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ]
  },
  (v14/*: any*/),
  (v4/*: any*/)
],
v20 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "count"
},
v22 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v23 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v22/*: any*/)
},
v24 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v25 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v13/*: any*/),
  (v23/*: any*/),
  {
    "alias": "tooltip",
    "args": (v24/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v24/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v22/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v26 = {
  "alias": "projectStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v27 = {
  "kind": "ScalarField",
  "name": "value"
},
v28 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v13/*: any*/),
    (v23/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectUpdatesQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v2/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProjectUpdates"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectUpdatesQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v2/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v3/*: any*/),
              {
                "args": (v5/*: any*/),
                "concreteType": "ProjectUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v8/*: any*/),
                              (v6/*: any*/),
                              {
                                "concreteType": "Workspace",
                                "kind": "LinkedField",
                                "name": "workspace",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "WorkspaceAIConfig",
                                    "kind": "LinkedField",
                                    "name": "aiConfig",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "enabled"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "watching"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "private"
                              },
                              {
                                "concreteType": "IconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v3/*: any*/),
                              (v9/*: any*/),
                              {
                                "concreteType": "ProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v7/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "concreteType": "UpdateNote",
                                    "kind": "LinkedField",
                                    "name": "notes",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v11/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "latestUpdateDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "startDate"
                              },
                              (v7/*: any*/),
                              {
                                "concreteType": "ProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v4/*: any*/),
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v9/*: any*/),
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "missedUpdate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "updateType"
                          },
                          {
                            "concreteType": "UserViews",
                            "kind": "LinkedField",
                            "name": "views",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "viewCount"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "objectType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "objectId"
                              },
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "viewed"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "concreteType": "ProjectChangelogItem",
                            "kind": "LinkedField",
                            "name": "changelog",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "newValue"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "oldValue"
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "LearningConnection",
                            "kind": "LinkedField",
                            "name": "learnings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "LearningEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Learning",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "type"
                                      },
                                      (v6/*: any*/),
                                      (v4/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "concreteType": "Project",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": (v18/*: any*/)
                                          },
                                          {
                                            "concreteType": "Goal",
                                            "kind": "LinkedField",
                                            "name": "goal",
                                            "plural": false,
                                            "selections": (v18/*: any*/)
                                          },
                                          {
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "creator",
                                            "plural": false,
                                            "selections": (v19/*: any*/)
                                          },
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "lastEditedBy",
                                            "plural": false,
                                            "selections": (v19/*: any*/)
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "lastEditedDate"
                                          }
                                        ],
                                        "type": "Highlight",
                                        "abstractKey": "__isHighlight"
                                      },
                                      (v20/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v21/*: any*/),
                              (v20/*: any*/)
                            ]
                          },
                          (v8/*: any*/),
                          {
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v10/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "commentText"
                                      },
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "concreteType": "UserPII",
                                            "kind": "LinkedField",
                                            "name": "pii",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v9/*: any*/),
                                              (v17/*: any*/),
                                              (v16/*: any*/)
                                            ]
                                          },
                                          (v4/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v20/*: any*/)
                            ]
                          },
                          (v10/*: any*/),
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/)
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v25/*: any*/)
                          },
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v13/*: any*/),
                              (v23/*: any*/),
                              (v28/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          (v11/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "archived"
                              },
                              (v12/*: any*/),
                              (v11/*: any*/),
                              (v4/*: any*/),
                              (v29/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v25/*: any*/)
                          },
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v23/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MilestoneConnection",
                            "kind": "LinkedField",
                            "name": "milestones",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MilestoneEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Milestone",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v4/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetDate"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetDateType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "status"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          (v29/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  },
                                  {
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:10)"
              },
              {
                "args": (v5/*: any*/),
                "handle": "connection",
                "key": "ProjectUpdates__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "04ba9e4f0396b2eac9ed56b6a496c484",
    "id": null,
    "metadata": {},
    "name": "ProjectUpdatesQuery",
    "operationKind": "query",
    "text": "query ProjectUpdatesQuery(\n  $key: String!\n  $isUpdatesTab: Boolean!\n) {\n  project: projectByKey(key: $key) {\n    key @include(if: $isUpdatesTab)\n    ...ProjectUpdates @include(if: $isUpdatesTab)\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment EditProjectUpdate on ProjectUpdate {\n  id\n  uuid\n  summary\n  newState {\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    title\n    uuid\n    archived\n    id\n  }\n  project {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    startDate\n    creationDate\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n  }\n  missedUpdate\n  updateType\n  creationDate\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsInUpdate\n}\n\nfragment EditableProjectUpdateCard on ProjectUpdate {\n  id\n  project {\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  creationDate\n  ...ProjectUpdateCard\n  ...EditProjectUpdate\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsInUpdate on ProjectUpdate {\n  project {\n    uuid\n    id\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  views {\n    ...ViewsTracker\n    id\n  }\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  views {\n    ...Views\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newState {\n    projectStateValue: value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ProjectUpdates on Project {\n  updates(first: 10) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableProjectUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment ViewersModalFragment on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment Views on UserViews {\n  viewCount\n  ...ViewsTooltipContent\n  ...ViewersModalFragment\n}\n\nfragment ViewsTooltipContent on UserViews {\n  viewCount\n  objectType\n  objectId\n}\n\nfragment ViewsTracker on UserViews {\n  viewed\n}\n"
  }
};
})();

(node as any).hash = "47cd6fdd6e942cf1762637868e61ff2e";

export default node;
